import {useTranslation} from 'react-i18next'
import {ListEmptyState} from '@/components/section-card'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {ActionRow} from '@/components/plan-action-row'
import type {SgsstAction} from '@/hooks/sgsst/plan/use-actions'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'
import type {SgsstItem} from '@/hooks/sgsst/evaluacion/use-sgsst'
import type {Cop} from '@/lib/money'

export function PlanFlatList({
  businessId,
  data,
  page,
  onPageChange,
  planYear,
  editable,
  itemByCode,
  perActionRiskByStandard,
  onEdit,
  onDelete,
  onOpenNotes,
}: {
  businessId: string
  data: Page<SgsstAction> | undefined
  page: number
  onPageChange: (page: number) => void
  planYear: number
  editable: boolean
  itemByCode: Map<string, SgsstItem>
  perActionRiskByStandard: Map<string | null, Cop | null>
  onEdit: (action: SgsstAction, item: SgsstItem | null) => void
  onDelete: (action: SgsstAction) => void
  onOpenNotes: (action: SgsstAction) => void
}) {
  const {t} = useTranslation()
  if (!data) return null

  if (data.items.length === 0) {
    return (
      <div className="surface mx-auto max-w-2xl">
        <ListEmptyState page title={t('plan.search.noMatches')} />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="surface overflow-hidden px-4" data-testid="plan-flat-list">
        {data.items.map((action) => {
          const item = action.standard_code ? (itemByCode.get(action.standard_code) ?? null) : null
          return (
            <ActionRow
              key={action.id}
              businessId={businessId}
              action={action}
              planYear={planYear}
              editable={editable}
              risk={perActionRiskByStandard.get(action.standard_code ?? null) ?? null}
              standardLabel={{code: action.standard_code, name: item?.name}}
              onEdit={(a) => onEdit(a, item)}
              onDelete={onDelete}
              onOpenNotes={onOpenNotes}
            />
          )
        })}
      </div>
      {data.total > data.page_size && (
        <PaginationBar page={page} pageSize={data.page_size} total={data.total} onPageChange={onPageChange} />
      )}
    </div>
  )
}
